// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://recrutement-stir.com/api", // Laravel API base URL
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default api;
